<template>
  <v-dialog
    v-model="dialog"
    width="330px">
    <div class="dialog-container">
      <div class="dialog-header">
        <span>Send {{ methodsList[type] }}</span>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div
            v-show="type === 0"
            class="form-box">
            <span class="label">User</span>
            <el-form-item prop="customer_id">
              <v-select
                v-model="formData.customer_id"
                labelKey="isrd_nm"
                :list="customerOptionsUser"
                remote
                nameGroup
                disabled
                :remoteMethod="remoteMethodUser"
              >
                <template #default="scope">
                  <div class="send-info">
                    <div class="info">
                      {{ scope.item.isrd_nm }}
                    </div>
                  </div>
                </template>
              </v-select>
            </el-form-item>

          </div>
          <div
            v-show="type === 3"
            class="form-item">
            <span class="label">Email</span>
            <el-input
              v-if="inputNo"
              v-model="email"
              :disabled="isReferTicket"
              placeholder="請輸入郵箱"></el-input>
            <v-select
              v-else
              v-model="emailCustomerId"
              labelKey="email"
              :disabled="isReferTicket"
              :list="customerOptionsEmail"
              remote
              :remoteMethod="remoteMethodEmail"
              @changeData="changeEmail">
              <template #default="scope">
                <div class="send-info">
                  <div class="info">
                    {{ scope.item.name }} - {{ scope.item.email }}
                  </div>
                  <span>Client</span>
                </div>
              </template>
            </v-select>
          </div>
          <div
            v-show="type === 2 || type === 1"
            class="form-item">
            <span class="label">Phone No.</span>
            <el-input
              v-if="inputNo"
              v-model="phone"
              :disabled="isReferTicket"
              type="number"
              placeholder="請輸入號碼"></el-input>
            <v-select
              v-else
              v-model="phoneCustomerId"
              labelKey="phone"
              :disabled="isReferTicket"
              :list="customerOptionsPhone"
              remote
              :remoteMethod="remoteMethod"
              @changeData="changePhone">
              <template #default="scope">
                <div class="send-info">
                  <div class="info">
                    {{ scope.item.name }} - {{ scope.item.phone }}
                  </div>
                </div>
              </template>
            </v-select>

          </div>
          <div class="form-item">
            <span class="label">Content</span>
            <el-form-item prop="content">
              <v-input
                v-model="formData.content"
                type="textarea"
                :rows="4"></v-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="flex-sb-center">
          <div>
            <v-button
              gray
              @click="handlerCancel">Cancel
            </v-button>
          </div>
          <div>
            <v-button
              green
              @click="handlerSend">Send
            </v-button>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {sendSMS, sendEmail, sendWhatsApp, sendNotification,sendReferralBuyableSMS} from '@/api/ticket'
import {getCustomerOptionsPhone} from '@/api/common'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'NewContactDialog',
  mixins: [MixinOptions,MixinRules],
  props: {
    type: {
      type: Number,
      default: 0
    },
    ticketId: {
      type: [String, Number],
      default: ''
    },
    referId: {
      type: [String, Number],
      default: ''
    },
    initCustomerId: {
      type: [Number, String],
      default: ''
    },
    shareLink: {
      type: String,
      default: ''
    },
    isInput: {
      type: Boolean,
      default: false
    },
    customerData:{
      type: Object,
      default: () => ({})
    },
    initPhone: {
      type: String,
      default: ''
    },
    initEmail: {
      type: String,
      default: ''
    },
    initCustomerName: {
      type: String,
      default: ''
    },
    isReferTicket:{
      type: Boolean,
      default: false
    },
    isReferBuyable:{
      type: Boolean,
      default: false
    },
    isTicket:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: false,
      customerId: '',
      emailCustomerId: '',
      email: '',
      phone: '',
      phoneCustomerId: '',
      content: '',
      methodsList: ['Notification', 'SMS', 'WhatsApp', 'Email'],
      customerPhoneData: [],
      formData:{
        customer_id:'',
        content:''
      }
    }
  },

  computed: {
    ...mapState('common', ['customerOptionsPhone', 'customerOptionsUser', 'customerOptionsEmail']),
    // customerPhoneData() {
    //   this.getCustomerOptionsPhone()
    //   return[]
    //   // return this.customerOptions.filter(item => (item.phone && item.name && String(item.name).trim()))
    // },
    customerEmailData() {
      return this.customerOptions.filter(item => (item.email && item.name && String(item.name).trim()))
    },
    inputNo(){
      return this.isInput
    }
  },
  watch: {
    initCustomerId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.phoneCustomerId = val
          this.emailCustomerId = val
          this.formData.customer_id =val
        }
      }
    },
    initPhone: {
      immediate: true,
      handler(val) {
        this.phone = val
        if(!this.initCustomerId)
          this.remoteMethod(val, this.type)
      }
    },
    initEmail: {
      immediate: true,
      handler(val) {
        this.email = val
        if(!this.initCustomerId)
          this.remoteMethodEmail(val, this.type)
      }
    },
    shareLink: {
      immediate: true,
      handler(val) {
        if (val)
        {
          // this.inputNo = true
          this.formData.content = val
        }
      }
    },
    customerData:{
      immediate: true,
      handler(val) {
        if (val)
        {
          let { contact_phone='',contact_email=''} =val||{}
          this.email=contact_email?contact_email:this.email
          this.phone=contact_phone?contact_phone:this.phone
          console.log('data---',this.phone)
        }
      }
    },
    initCustomerName:{
      immediate: true,
      handler(val) {
        this.remoteMethodUser(val)
      }
    }
  },
  created() {
    this.setCustomerOptionNUll()
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone', 'setCustomerOptionNUll', 'getCustomerOptionsEmail', 'getCustomerOptionsUser']),
    changeDialog() {
      this.dialog = !this.dialog
    },
    changeEmail(data) {
      this.email = data.email
    },
    changePhone(data) {
      this.phone = data.phone
    },
    initData() {
      // this.email = ''
      // this.emailCustomerId = ''
      // this.phone = ''
      // this.phoneCustomerId = ''

      this.formData.content = this.shareLink?this.shareLink:''
      // this.customerId = ''
      this.dialog = false
    },
    handlerCancel() {
      this.dialog = false
      this.formData.content = this.shareLink?this.shareLink:''
      // this.setCustomerOptionNUll()
    },
    handlerSend() {
      const type = this.type
      if(this.isReferBuyable){
        let params = {
          content: this.formData.content,
          type:type==3?2:1,
          refer_id:this.referId
        }
        this.$refs.form.validate((valid, rules) => {
          if(valid){
            this.network().sendReferralBuyableSMS(params)
          }
        })
        return
      }
      if (type === 1) {
        this.network().sendSMS(this.phone)
      } else if (type === 3) {
        this.network().sendEmail(this.email)
      } else if (type === 0) {
        this.$refs.form.validate((valid, rules) => {
          if(valid){
            this.network().sendNotification()
          }
        })
      }
    },
    handlerResult(data) {
      this.initData()
      // this.setCustomerOptionNUll()
      this.$emit('success')
      this.$message({
        type: 'success',
        message: data.message_language
      })
    },
    remoteMethod(query, type) {
      if (query !== '') {
        this.getCustomerOptionsPhone(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    remoteMethodEmail(query) {
      if (query !== '') {
        this.getCustomerOptionsEmail(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    network() {
      return {
        sendReferralBuyableSMS: async (params) => {
          params = {...params}
          if (this.ticketId !== '' && !this.inputNo) {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendReferralBuyableSMS({
            ...params
          })

          this.handlerResult(data)
        },
        sendSMS: async () => {
          let params = {}
          if (this.ticketId !== '' && !this.inputNo) {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendSMS({
            content: this.formData.content,
            phone: this.phone,
            customer_id: this.inputNo ? '' : this.phoneCustomerId,
            ...params
          })

          this.handlerResult(data)
        },
        sendEmail: async () => {
          let params = {}
          if (this.ticketId !== '' && !this.inputNo) {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendEmail({
            content: this.formData.content,
            email: this.email,
            customer_id: this.inputNo ? '' : this.emailCustomerId,
            ...params
          })
          this.handlerResult(data)
        },
        sendWhatsApp: async () => {
          let params = {}
          if (this.ticketId !== '') {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendWhatsApp({
            content: this.formData.content,
            phone: this.phone,
            customer_id: this.phoneCustomerId,
            ...params
          })
          this.handlerResult(data)
        },
        sendNotification: async () => {
          let params = {}
          if (this.ticketId !== '') {
            params.ticket_id = this.ticketId
          }
          const {data} = await sendNotification({
            content: this.formData.content,
            customer_id: this.formData.customer_id,
            ...params
          })
          this.handlerResult(data)
          this.$refs.form.clearValidate('content')
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
  .dialog-container {
    .dialog-header {
      padding: 16px;
      background: #F6F8FA;
      border-bottom: 1px solid #E1E4E8;
      border-radius: 6px 6px 0 0;
      span{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #1B1F23;
      }
    }
    .dialog-body{
      padding: 20px 15px;
    }
    h3 {
      padding-bottom: 10px;
    }
    p {
      padding-bottom: 10px;
    }
    .form-item {
      & > span {
        font-weight: 600;
        font-size: 14px;
      }
    }
    .dialog-content {
      //   padding-top: 15px;
      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
</style>
